import { render, staticRenderFns } from "./CellCalendarIABeta.vue?vue&type=template&id=63df42d4&scoped=true&"
import script from "./CellCalendarIABeta.vue?vue&type=script&lang=js&"
export * from "./CellCalendarIABeta.vue?vue&type=script&lang=js&"
import style0 from "./CellCalendarIABeta.vue?vue&type=style&index=0&id=63df42d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df42d4",
  null
  
)

export default component.exports